import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.prmissionTab.title, 'Permissions'),
  module: () => __(translations.prmissionTab.module, 'Module'),
  permission: () => __(translations.prmissionTab.permission, 'Permissions'),
};
